import { Link } from "react-router-dom"
import { XCircle } from "lucide-react"

export function CheckoutCancel() {
  return (
    <div className="mx-auto max-w-xl px-4 py-16 text-center">
      <XCircle className="mx-auto h-12 w-12 text-brand-muted" />
      <h1 className="mt-4 text-2xl font-semibold">Kauf abgebrochen</h1>
      <p className="mt-2 text-brand-muted">
        Es wurde nichts berechnet. Ihr Warenkorb bleibt erhalten — Sie können den Kauf jederzeit
        erneut starten.
      </p>
      <div className="mt-8">
        <Link
          to="/"
          className="rounded-full bg-brand-blue px-4 py-2 text-sm font-medium text-white transition hover:opacity-90"
        >
          Zurück zum Katalog
        </Link>
      </div>
    </div>
  )
}
